import RichTextInput from 'ra-input-rich-text'
import React from 'react'
import {
    List,
    Edit,
    SimpleForm,
    TextInput,
    Datagrid,
    TextField,
} from 'react-admin'

export const commonUnitOfMeasureEdit = ({ ...props }) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="id" />
            <TextInput source="description" />
            <TextInput source="abbreviation" />
        </SimpleForm>
    </Edit>
)

export const commonUnitOfMeasureList = (props: any) => {
    return (
        <List {...props}>
            <Datagrid rowClick="edit">
                <TextField source="id" />
                <TextField source="description" />
                <TextField source="abbreviation" />
            </Datagrid>
        </List>
    )
}
